import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/cn"

// Pill chips. Callers pass tinted color pairs via className
// (e.g. "bg-success/10 text-success") — the base stays neutral.
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border border-transparent px-2 py-[2.5px] text-[10.5px] font-semibold leading-none",
  {
    variants: {
      variant: {
        default: "bg-bg text-muted",
        secondary: "bg-black/[0.05] text-text",
        outline: "border-black/[0.1] bg-transparent text-text",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
